import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { OutrasReceitasEditarRoutingModule } from "./outras-receitas-editar-routing.module";
import { OutrasReceitasEditarComponent } from "./outras-receitas-editar.component";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { TableModule } from 'primeng/table';
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from "primeng/divider";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { InputMaskModule } from 'primeng/inputmask';
import { MessagesModule } from 'primeng/messages';
import {InputSwitchModule} from 'primeng/inputswitch';
import {CheckboxModule} from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from "primeng/inputnumber";
import { ProgressSpinnerModule } from "primeng/progressspinner";





@NgModule({
    imports: [
        CommonModule,     
        OutrasReceitasEditarRoutingModule,
        FormsModule,
        TableModule,
        ButtonModule,
        InputTextModule,
        TooltipModule,
        DividerModule,
        DropdownModule,
        InputTextareaModule,
        InputMaskModule,
        MessagesModule,
        InputSwitchModule,
        CheckboxModule,
        CalendarModule,
        InputNumberModule,
        ProgressSpinnerModule

    ],
    declarations: [OutrasReceitasEditarComponent]
})
export class OutrasReceitasEditarModule { }
